import { Component, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.less']
})
export class ImprintComponent extends AppComponentBase {

    constructor(
        injector: Injector) {
        super(injector);
    }

}
